(() => {
  const body = document.body;
  const toggle = document.querySelector('[data-menu-toggle]');
  if (toggle) toggle.addEventListener('click', () => {
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    body.classList.toggle('menu-open', !expanded);
  });
  const grid = document.querySelector('[data-product-grid]');
  const colourSelect = document.querySelector('[data-colour-filter]');
  const typeButtons = [...document.querySelectorAll('[data-type-filter]')];
  let currentType = 'all';
  function filterCards() {
    if (!grid) return;
    const colour = colourSelect ? colourSelect.value : 'all';
    let visible = 0;
    grid.querySelectorAll('.product-card').forEach(card => {
      const show = (currentType === 'all' || card.dataset.type === currentType) && (colour === 'all' || card.dataset.colour === colour);
      card.hidden = !show;
      if (show) visible += 1;
    });
    const noResults = document.querySelector('.no-results');
    if (noResults) noResults.hidden = visible > 0;
  }
  typeButtons.forEach(button => button.addEventListener('click', () => {
    currentType = button.dataset.typeFilter;
    typeButtons.forEach(item => item.classList.toggle('active', item === button));
    filterCards();
  }));
  if (colourSelect) colourSelect.addEventListener('change', filterCards);
  document.querySelectorAll('.product-form').forEach(form => {
    const data = form.parentElement.querySelector('[data-product-json]');
    if (!data) return;
    const variants = JSON.parse(data.textContent);
    const choices = {};
    form.querySelectorAll('.option-value.selected').forEach(button => choices[button.dataset.optionPosition] = button.dataset.optionValue);
    form.querySelectorAll('.option-value').forEach(button => button.addEventListener('click', () => {
      choices[button.dataset.optionPosition] = button.dataset.optionValue;
      form.querySelectorAll(`.option-value[data-option-position="${button.dataset.optionPosition}"]`).forEach(item => item.classList.toggle('selected', item === button));
      const variant = variants.find(item => Object.keys(choices).every(pos => item[`option${pos}`] === choices[pos]));
      if (!variant) return;
      form.querySelector('[data-variant-id]').value = variant.id;
      const price = form.parentElement.querySelector('[data-product-price]');
      if (price) price.textContent = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(variant.price / 100);
      const submit = form.querySelector('[type="submit"]');
      if (submit) submit.disabled = !variant.available;
    }));
  });

  // =========================================================
  // ASSISTANT DE CHAT (FAQ)
  // =========================================================
  const chatRoot = document.querySelector('[data-gianni-chat]');
  if (chatRoot) {
    const chatToggle = chatRoot.querySelector('[data-chat-toggle]');
    const panel = chatRoot.querySelector('[data-chat-panel]');
    const closeBtn = chatRoot.querySelector('[data-chat-close]');
    const messagesEl = chatRoot.querySelector('[data-chat-messages]');
    const form = chatRoot.querySelector('[data-chat-form]');
    const input = chatRoot.querySelector('[data-chat-input]');

    function normalizeChat(value) {
      return (value || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim();
    }

    function addMessage(text, from) {
      const bubble = document.createElement('div');
      bubble.className = 'gianni-chat-bubble gianni-chat-bubble--' + from;
      bubble.textContent = text;
      messagesEl.appendChild(bubble);
      messagesEl.scrollTop = messagesEl.scrollHeight;
    }

    const rules = [
      { keywords: ['taille', 'tailles', 'pointure', 'gabarit', 'morphologie'], answer: "Les chemises vont du M au 3XL et les costumes du 48 au 60. Le détail des tailles est indiqué sur chaque fiche produit." },
      { keywords: ['livraison', 'delai', 'expedition', 'envoi', 'colis'], answer: "Nous livrons partout en France métropolitaine, avec un suivi de commande à chaque étape." },
      { keywords: ['retour', 'rembours', 'echange', 'annuler'], answer: "Vous avez 14 jours après réception pour nous retourner un article qui ne convient pas." },
      { keywords: ['paiement', 'payer', 'carte', 'paypal', 'facture'], answer: "Les moyens de paiement disponibles s'affichent au moment de valider votre commande." },
      { keywords: ['matiere', 'tissu', 'composition', 'entretien', 'laver'], answer: "La composition et l'entretien de chaque pièce sont précisés dans sa description produit." },
      { keywords: ['contact', 'email', 'mail', 'joindre', 'appeler', 'telephone'], answer: "Vous pouvez nous écrire directement à zignelli2@gmail.com, on vous répond au plus vite." },
      { keywords: ['prix', 'combien', 'tarif', 'coute'], answer: "Les chemises sont à partir de 39,95 € et les costumes deux pièces à partir de 259,95 €." },
      { keywords: ['couleur', 'coloris', 'teinte'], answer: "Chaque pièce est disponible en 7 coloris, visibles directement sur sa fiche produit." },
      { keywords: ['stock', 'disponible', 'rupture'], answer: "La disponibilité par taille et par couleur est indiquée en temps réel sur la fiche produit." },
      { keywords: ['bonjour', 'salut', 'hello', 'bonsoir', 'coucou'], answer: "Bonjour ! Je peux vous renseigner sur les tailles, la livraison, les retours, les prix ou les coloris. Que voulez-vous savoir ?" },
      { keywords: ['merci'], answer: "Avec plaisir ! N'hésitez pas si vous avez d'autres questions." }
    ];

    const fallback = "Je n'ai pas la réponse précise à cette question. Écrivez-nous à zignelli2@gmail.com et on vous répond directement.";

    function respond(question) {
      const normalized = normalizeChat(question);
      const match = rules.find(rule => rule.keywords.some(keyword => normalized.includes(keyword)));
      addMessage(match ? match.answer : fallback, 'bot');
    }

    function openChat() {
      panel.hidden = false;
      chatToggle.setAttribute('aria-expanded', 'true');
      if (!messagesEl.children.length) {
        addMessage("Bonjour, je suis l'assistant GIANNI ANGELO. Posez-moi une question sur les tailles, la livraison, les retours ou les coloris.", 'bot');
      }
      input.focus();
    }

    function closeChat() {
      panel.hidden = true;
      chatToggle.setAttribute('aria-expanded', 'false');
    }

    chatToggle.addEventListener('click', () => {
      if (panel.hidden) openChat(); else closeChat();
    });
    if (closeBtn) closeBtn.addEventListener('click', closeChat);

    form.addEventListener('submit', event => {
      event.preventDefault();
      const value = input.value.trim();
      if (!value) return;
      addMessage(value, 'user');
      input.value = '';
      setTimeout(() => respond(value), 300);
    });
  }
})();
